import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import classnames from 'classnames';
import styles from './styles.scss';

export default function MaterialCheckbox(props) {
  const isReduxForm = !!props.input;
  let settings = {
    label: props.label,
    disabled: props.disabled,
    className: classnames(styles.materialCheckbox, props.className),
    onCheck: isReduxForm ? props.input.onChange : props.onChange,
    checked: isReduxForm ? !!props.input.value : !!props.value,
    style: props.style,
    iconStyle: { fill: '#1899d8' }
  };

  if (props.size === 'lg') {
    settings.iconStyle.height = '32px';
    settings.iconStyle.width = '32px';
  }

  if (props.size === 'sm') {
    settings.iconStyle.height = '20px';
    settings.iconStyle.width = '20px';
  }

  if (isReduxForm) {
    settings = { ...settings, ...props.input };
  }

  return (
    <div style={{ display: 'inline-block' }}>
      <Checkbox {...settings} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/util/materialCheckbox/index.js